var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-honeypot",attrs:{"aria-hidden":"true"}},[_c('label',[_vm._v(" Website "),_c('input',{attrs:{"type":"text","name":"website","tabindex":"-1","autocomplete":"off"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }